function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.87 12.13H5.854v14.018H19.87V12.13zm-14.017-2a2 2 0 00-2 2v14.018a2 2 0 002 2H19.87a2 2 0 002-2V12.13a2 2 0 00-2-2H5.853z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.982 6H26v14.018h-2v2h2a2 2 0 002-2V6a2 2 0 00-2-2H11.982a2 2 0 00-2 2v2.063h2V6z",
    fill: props.color
  }));
}

export default SvgIconCopyFilled;